import { axiosWithToken } from '../utils/functions/apiCallWithToken';
import { addBreadcrumbPaymentInit } from '../utils/functions/sentryUtils';
import { SERVER_URL as serverURL } from '../core/config';


export const createTransaction = async (data) => {
    const result = await axiosWithToken(`${serverURL}/transaction/create/`, 'post', data);
    return result;
}

export const fetchTransaction = async (param) => {
    const result = await axiosWithToken(`${serverURL}/transaction/`, 'get', {}, param);
    return result;
}

export const fetchCouponTransaction = async (couponId) => {
    const result = await axiosWithToken(`${serverURL}/transaction/coupon/${couponId}`, 'get', {}, {});
    return result;
}

export const claim = async (data) => {
    const result = await axiosWithToken(`${serverURL}/transaction/claim/`, 'post', data);
    return result;
}

export const createPaymentIntent = async (data) => {
    addBreadcrumbPaymentInit('stripe');
    const result = await axiosWithToken(`${serverURL}/transaction/create-payment-intent/`, 'post', data);
    return result;
}

export const fetchRevenueTransaction = async() => {
    const result = await axiosWithToken(`${serverURL}/transaction/revenue`, 'get', {});
    return result;
}
export const createNowPaymentsInvoice = async (data) => {
    addBreadcrumbPaymentInit('nowpayments');
    const result = await axiosWithToken(`${serverURL}/transaction/create-nowpayments-invoice/`, 'post', data);
    return result;
}

export const confirmNowPaymentsPayment = async (data) => {
    const result = await axiosWithToken(`${serverURL}/transaction/confirm-nowpayments-payment/`, 'post', data);
    return result;
}

export const confirmStripePayment = async (data) => {
    const result = await axiosWithToken(`${serverURL}/transaction/confirm-stripe-payment/`, 'post', data);
    return result;
}

export const createPaypalOrder = async (data) => {
    addBreadcrumbPaymentInit('paypal');
    const result = await axiosWithToken(`${serverURL}/transaction/create-paypal-order/`, 'post', data);
    return result;
}

export const capturePaypalOrder = async (data) => {
    const result = await axiosWithToken(`${serverURL}/transaction/capture-paypal-order/`, 'post', data);
    return result;
}
